import type { CartSellerGroupsV2 } from '@redteclab/api/clients/bully'
import classNames from 'clsx'
import type { FC } from 'react'
import { useSelector } from 'react-redux'

import { getLinePercentAffectedProductIds } from 'shared/utils/getLinePercentAffectedProductIds'
import { type IState } from 'types/redux/store'
import Price from 'views/components/atoms/Price'
import ImageRow, {
  type PropTypes as ImageRowProps,
} from 'views/components/molecules/ImageRow'
import SellerInfoHeader from 'views/components/organisms/SellerInfoHeader'

const AppliedPromotionInformationModalContent: FC = () => {
  const { data: cart } = useSelector((state: IState) => state.cart)
  // the state object uses a "local" type which has several type inconsistencies with the type defined in the API
  const sellerGroups = (cart.sellerGroups as CartSellerGroupsV2[]) ?? []

  const linePercentPromotion = cart.sellerGroups
    .map(group => group.discounts)
    .flat()
    .find(discount => discount.promotionType === 'linePercent')

  return (
    <>
      {sellerGroups?.map((group, idx) => {
        const affectedProductIdsPerSellerGroup =
          getLinePercentAffectedProductIds(group)
        const imageRowProps: ImageRowProps = {
          items: group.groupEntries
            .map(entry => entry.items)
            .flat()
            .filter(product =>
              affectedProductIdsPerSellerGroup.includes(product.offerId)
            ),
        }

        return affectedProductIdsPerSellerGroup.length === 0 ||
          !linePercentPromotion ? null : (
          <div
            key={`${group.sellerName}-${group.sellerId}`}
            className={classNames(
              'u-border-radius u-background-color--background u-padding-large',
              {
                'u-margin--bottom':
                  sellerGroups.length > 1 && idx !== sellerGroups.length,
              }
            )}
          >
            <div className="l-flex l-flex--distribute-space l-flex--vertical l-flex--start">
              <SellerInfoHeader
                idx={idx + 1}
                max={sellerGroups.length}
                sellerName={group.sellerName}
                disabled={false}
              />

              <ImageRow {...imageRowProps} />
            </div>

            <hr className="u-margin-large--bottom u-margin-large--top u-border--bottom u-border-color--grey" />
            <div className="l-flex l-flex--distribute-space a-h4 u-no-margin--bottom">
              <div>{linePercentPromotion.code}</div>
              <div className="u-color--positive">
                <Price
                  amount={
                    linePercentPromotion?.value
                      ? -linePercentPromotion?.value
                      : 0
                  }
                  symbolLeft
                  decimalPlaces={2}
                />
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default AppliedPromotionInformationModalContent
